import React from 'react';
import { Divider, Grid, Typography } from '@mui/material';

const DrawerHeaderText = ({ children, isDrawerOpen }) => {
  return (
    <>
      <Grid
        sx={{
          textTransform: 'uppercase',
          display: !isDrawerOpen ? 'none' : 'block'
        }}
      >
        <Typography variant="overline" component="span">
          {children}
        </Typography>
      </Grid>
      <Grid
        sx={[
          !isDrawerOpen && {
            my: 0.5,
            px: 0.5,
            width: '100%'
          }
        ]}
        size="grow"
      >
        <Divider />
      </Grid>
    </>
  );
};

export default DrawerHeaderText;
